import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { errorHandler } from '@/lib/ErrorHandler';
import { HttpError, ValidationError } from '@/lib/exception';
import { getClient } from '@/lib/restClient';
import { AuthService, PasswordResetForm } from '@/services/Auth';

export const usePasswordReset = (): ((
  password: string,
  passwordConfirmation: string
) => Promise<void>) => {
  const authService = new AuthService(getClient());
  const history = useHistory();

  const url = window.location.search;
  const token = new URLSearchParams(url).get('token');

  const invalidTokenHandling = () => {
    alert(
      '無効なトークンです。再度パスワード再設定のリクエストを行ってください。'
    );
    return history.replace('/forgot-password');
  };

  useEffect(() => {
    const validateToken = async () => {
      if (!token) {
        return history.replace('/forgot-password');
      }
      await authService
        .validateToken({ token })
        .catch(() => invalidTokenHandling());
    };
    validateToken();
  }, [token]);

  const passwordReset = async (
    password: string,
    passwordConfirmation: string
  ) => {
    if (password !== passwordConfirmation) {
      throw new ValidationError('パスワードが一致しません');
    }
    if (!token) {
      throw new Error('トークンが確認できませんでした');
    }

    const body: PasswordResetForm = {
      one_time_token: token,
      password: password,
    };

    return await authService
      .passwordReset(body)
      .then(() => {
        alert('パスワードの再設定が完了しました');
        history.push('/login');
      })
      .catch((error: Error) => {
        if (error instanceof HttpError && error.status === 401) {
          return invalidTokenHandling();
        }
        errorHandler({ error });
      });
  };

  return passwordReset;
};
